import { useMemo } from 'react';
import { avatarSvgDataUrl } from '../../utils/composeAvatarSvg';

function initialsFrom(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export default function MobileAvatar({ avatar, name, photoUrl, size = 36 }) {
  const src = useMemo(() => {
    if (avatar && typeof avatar === 'object') return avatarSvgDataUrl(avatar);
    return null;
  }, [avatar]);

  const style = {
    width: size,
    height: size,
    borderRadius: '50%',
    flexShrink: 0,
    objectFit: 'cover',
    background: '#E8EBF5',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
  };

  if (src) {
    return (
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        style={style}
      />
    );
  }

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        width={size}
        height={size}
        style={style}
        referrerPolicy="no-referrer"
      />
    );
  }

  return (
    <span
      style={{
        ...style,
        fontSize: Math.max(11, size * 0.34),
        fontWeight: 700,
        color: '#475569',
        background: '#e2e8f0',
      }}
    >
      {initialsFrom(name)}
    </span>
  );
}
